import AutocompleteInput from "components/form/input/AutocompleteInput";
import { useEffect, useState } from "react";

export default function TalhaoSelect({ fazenda, ...props }) {
    const [talhoes, setTalhoes] = useState([]);

    useEffect(() => {
        if (fazenda && fazenda.data.talhoesFazenda) {
            setTalhoes(["", ...fazenda.data.talhoesFazenda]);
        }
    }, [fazenda]);

    return <AutocompleteInput
        options={talhoes}
        getOptionLabel={(option) => option.nome || ""}
        isOptionEqualToValue={(option, value) => option.nome === value.nome}
        {...props}
    />
}
